import { Link } from 'react-router-dom';

const modules = [
  {
    to: '/settings/sales',
    icon: 'ri-settings-4-line',
    title: 'Configuración de Venta',
    description:
      'Moneda, impuestos, descuentos, métodos de pago, numeración de facturas, impresión y más.',
    available: true,
  },
  {
    to: '/settings/printers',
    icon: 'ri-printer-cloud-line',
    title: 'Impresoras',
    description: 'Configura impresoras de facturas, reportes y etiquetas. Impresión por navegador o Electron.',
    available: true,
  },
  {
    to: '/settings/business',
    icon: 'ri-store-3-line',
    title: 'Datos de la sucursal',
    description:
      'Nombre, RNC, ubicación, teléfono y logo de cada sucursal. Se usan en las facturas de esa sucursal.',
    available: true,
  },
  {
    to: '/settings/social',
    icon: 'ri-share-circle-line',
    title: 'Redes sociales y contacto',
    description:
      'Instagram, Facebook y TikTok que aparecen en el encabezado del catálogo público.',
    available: true,
  },
  {
    to: '/settings/backup',
    icon: 'ri-database-2-line',
    title: 'Copias de seguridad',
    description:
      'Crea, descarga y consulta el historial de respaldos del sistema o de una sucursal.',
    available: true,
  },
  {
    to: '/settings/logs',
    icon: 'ri-shield-check-line',
    title: 'Seguridad y actividad',
    description:
      'Registro de auditoría: inicios de sesión, cambios de productos, inventario, caja, ajustes, errores y accesos no autorizados.',
    available: true,
  },
];

export default function SettingsPage() {
  return (
    <div className="max-w-5xl mx-auto">
        <span className="inline-flex items-center gap-1.5 rounded-md border border-primary-200 bg-primary-50 px-3 py-1.5 text-sm font-semibold text-primary-700">
          <i className="ri-settings-3-line" />
          Configuración
        </span>
        <h1 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          Configuración
        </h1>
        <p className="mt-2 text-foreground-600 max-w-2xl">
          Administra los parámetros del sistema. Estas configuraciones serán utilizadas
          automáticamente por el punto de venta.
        </p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {modules.map((mod) => {
            const content = (
              <>
                <div
                  className={`w-11 h-11 rounded-lg flex items-center justify-center ${
                    mod.available
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-100 text-foreground-400'
                  }`}
                >
                  <i className={`${mod.icon} text-xl`} />
                </div>
                <h3 className="mt-4 font-heading font-semibold text-foreground-950">{mod.title}</h3>
                <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{mod.description}</p>
                <span
                  className={`mt-4 inline-flex items-center gap-1 text-xs font-medium ${
                    mod.available ? 'text-primary-700' : 'text-foreground-400'
                  }`}
                >
                  {mod.available ? (
                    <>
                      <i className="ri-arrow-right-line" /> Configurar
                    </>
                  ) : (
                    <>
                      <i className="ri-time-line" /> Próximamente
                    </>
                  )}
                </span>
              </>
            );

            if (mod.available) {
              return (
                <Link
                  key={mod.title}
                  to={mod.to}
                  className="rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300 hover:bg-background-100 transition cursor-pointer"
                >
                  {content}
                </Link>
              );
            }

            return (
              <div
                key={mod.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5 opacity-70"
              >
                {content}
              </div>
            );
          })}
        </div>
    </div>
  );
}